export default __webpack_public_path__ + "static/media/ann.a0a97ab8.jpg";